import * as React from "react";
import $ from "jquery";

export class LoadingBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isloading: false };
    }

    componentDidUpdate() {
        //TODO: we should show loading bar if process takes more than 0.4 seconds
        //if (this.props.isLoading) {
        //    $("#loadingBarPopup").modal('show');
        //}
        //else {
        //    setTimeout(function () {
        //        $("#loadingBarPopup").modal('hide');
        //    }, 400);
        //}
    }
    
    render() {
        return (
            <div className='modal' id='loadingBarPopup' role='dialog' aria-labelledby='exampleModalCenterTitle' aria-hidden='true' data-backdrop='false'>
                <div className='modal-dialog modal-dialog-centered' role='document'>
                    <div id="loadingBar"></div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/LoadingBar.js